import { render, staticRenderFns } from "./PaginationDicionario.vue?vue&type=template&id=2746dbfd&"
import script from "./PaginationDicionario.vue?vue&type=script&lang=js&"
export * from "./PaginationDicionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports